const DEFAULT_MAX_RECENT = 5;

// Moves `name` to the front of `current`, dropping any earlier occurrence, and caps the result at
// `max` entries.
export function pushRecentWorkflow(current: string[], name: string, max = DEFAULT_MAX_RECENT): string[] {
  return [name, ...current.filter((existing) => existing !== name)].slice(0, max);
}
